import { render, staticRenderFns } from "./plainLayout.vue?vue&type=template&id=24a903b0&scoped=true"
import script from "./plainLayout.vue?vue&type=script&lang=js"
export * from "./plainLayout.vue?vue&type=script&lang=js"
import style0 from "./plainLayout.vue?vue&type=style&index=0&id=24a903b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24a903b0",
  null
  
)

export default component.exports